import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";
import { setAsArray, decodeHtmlEntities } from "../utilfunctions/utilFunctions";

const BACKEND_URL = serviceUrl;

export const getMoneyGramUsers = async (searchText) => {
  try {
    const data = JSON.stringify({
      svc: "crm_users",
      pid: "getTransitionCustomer",
      dat: {
        location: "",
        searchstring: searchText,
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);

    // console.log("getMoneyGramUsersRes-------------",response.data.payload.header.body.customersintransition);

    return response.data.payload;
  } catch (error) {
    console.log(error);
  }
};

export const moneyGramAPI = async (formdata, serviceName, additionalParams) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "moneygram",
      pid: serviceName,
      dat: {
        ...formdata,
        ...sessionData,
        ...additionalParams
      }
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export function stripNamespaces(obj) {
  if (Array.isArray(obj)) {
    return obj.map(stripNamespaces);
  } else if (obj !== null && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.includes(":") ? key.split(":")[1] : key,
        stripNamespaces(value)
      ])
    );
  }
  return obj;
}

export function getMoneyGramErrorMessage(response) {
  let errorMsg = '';

  const moneygramErrorPath = response?.payload?.header?.apiresponse?.Envelope?.Body?.Fault;
  if (moneygramErrorPath) {
    const moneygramErrorMessage = moneygramErrorPath.faultstring;
    errorMsg += moneygramErrorMessage + "<br/>";

    if (moneygramErrorMessage === "Fee is too high") {
      errorMsg = "Send amount will be $0.00 after fees. Please enter a larger amount." + "<br/>";
    }
  }

  const secondaryMoneyGramErrorPath = moneygramErrorPath?.detail;
  if (secondaryMoneyGramErrorPath) {
    const errors = setAsArray(secondaryMoneyGramErrorPath.errors);

    for (const error of errors) {
      const moneygramError = error.error;
      let errorString = moneygramError.errorString;
      errorString = decodeHtmlEntities(errorString);
      errorString = errorString
        .replaceAll(/&#039;/g, "'")
        .replaceAll(/&quot;/g, "'")
        .replaceAll('{', '')
        .replaceAll('}', '')
        .replaceAll('cvc-complex-type.2.4.a: Invalid content was found starting with element', '')
        .replaceAll('http://www.moneygram.com/AgentConnect1512:', '')
        .replaceAll('senderPhotoIdType.', '');

      // Improved parsing: split by ', org.xml.sax.SAXParseException;'
      const splitErrors = errorString.split(', org.xml.sax.SAXParseException;').map(e => e.trim()).filter(e => e);

      const friendly_msgs = new Set();
      const field_issues = {};

      splitErrors.forEach(err => {
        // Helper to convert camelCase to Title Case
        const camelToTitle = (s) => s.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, c => c.toUpperCase());

        // Pattern 1: '' is not a valid value for 'type'
        const typeInvalidMatch = err.match(/'' is not a valid value for '(\w+)'/);
        if (typeInvalidMatch) {
          const typ = typeInvalidMatch[1];
          friendly_msgs.add(`Invalid value: must be a valid ${typ}.`);
        }

        // Pattern 2: The value '' of element 'field' is not valid
        const elementEmptyMatch = err.match(/The value '' of element '([\w]+)' is not valid/);
        if (elementEmptyMatch) {
          const field = camelToTitle(elementEmptyMatch[1]);
          field_issues[field] = "is required.";
        }

        // Pattern 3: Value '' is not facet-valid ... for type 'type'
        const facetInvalidMatch = err.match(/Value '' is not facet-valid .* for type '([\w]+)'/);
        if (facetInvalidMatch) {
          let typ = camelToTitle(facetInvalidMatch[1]).replace('Type', '').trim();
          friendly_msgs.add(`${typ} is required (cannot be empty).`);
        }

        // Pattern 4: cvc-type.3.1.3: The value '' of element 'field'
        const cvcTypeMatch = err.match(/cvc-type.3.1.3: The value '' of element '([\w]+)'/);
        if (cvcTypeMatch) {
          const field = camelToTitle(cvcTypeMatch[1]);
          field_issues[field] = "is required.";
        }
      });

      // Add field issues to messages
      Object.entries(field_issues).forEach(([field, issue]) => {
        friendly_msgs.add(`${field} ${issue}`);
      });

      // Join unique friendly messages
      errorMsg += Array.from(friendly_msgs).join("<br/>") + "<br/>";
    }
  }

  if (response?.Status === '2' && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transaction can not be completed at this time. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
    // errorMsg = "This transaction is under review. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
  } else if (response?.Status === '3' && response?.payload?.header?.callStatus === '1') {
    errorMsg = "This transaction can not be completed at this time. Please contact NCS for further assistance @1-649-946-4227 or support@onrevegrand.com";
  } else if (response?.payload?.msg) {
    let msg = response?.payload.msg;
    msg = msg.split('||');
    for (let msgString of msg) {
      errorMsg += msgString;
    }
  } else if (response?.payload?.Errors) {
    let errors = response?.payload?.Errors;
    if (!Array.isArray(errors)) {
      errors = [errors];
    }
    for (let error of errors) {
      errorMsg += error.Error.ErrorMsg;
    }
  } else if (response?.payload?.msg) {
    errorMsg += response?.payload?.msg;
  }
  errorMsg = errorMsg.replaceAll(/&(amp;)*#039;/g, "'");
  errorMsg = errorMsg.replaceAll(/&(amp;)*quot;/g, '"');
  errorMsg = errorMsg.replaceAll(/4pay/gi, "NCS");
  errorMsg = errorMsg.replaceAll(/&(amp;)*lt;/gi, "");
  errorMsg = errorMsg.replaceAll(/&(amp;)*gt;/gi, "");
  errorMsg = errorMsg.replaceAll(/something went wrong/gi, "");
  return errorMsg;
}